import {
  Flex,
  Select,
  Input,
  InputGroup,
  InputLeftAddon,
  SimpleGrid,
} from "@chakra-ui/react";

import React from "react";
import ApiService from "services/api.js";

export default function HeaderBillCancelData(props) {
  // custom variable
  const {
    inputDateFrom,
    inputDateTo,
    inputBill,
    inputBranch,
    inputBranchName,
    setDateFrom,
    setDateTo,
    setBill,
    setInputBranch,
    setInputBranchName,
  } = props;
  const options = ApiService.optionsBranch()
  const allBranchValue = options?.map(data => data.id).join(',');
  return (
    <Flex px="25px" justify="space-between" mb="20px" align="center">
      <SimpleGrid
        w="100%"
        mb="20px"
        columns={{ sm: 1, md: 2 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <InputGroup>
          <InputLeftAddon children="Date From" />
          <Input
            focusBorderColor="black"
            placeholder="Select Date From"
            borderRadius="16px"
            type="date"
            value={inputDateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Date To" />
          <Input
            focusBorderColor="black"
            placeholder="Select Date To"
            borderRadius="16px"
            type="date"
            value={inputDateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Branch ID" />
          <Select
            value={inputBranch}
            onChange={(e) => setInputBranch(e.target.value)}
          >
            <option value={allBranchValue}>All Branch</option>
            {options?.map(function (data) {
              return <option key={data.id} value={data.id}>{data.name_branch}</option>;
            })}
          </Select>
          {/* <Input
            focusBorderColor="black"
            placeholder="Input Branch"
            borderRadius="16px"
            value={inputBranch}
            onChange={(e) => setInputBranch(e.target.value)}
          /> */}
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Branch Name" />
          <Input
            focusBorderColor="black"
            placeholder="Input Branch Name"
            borderRadius="16px"
            value={inputBranchName}
            onChange={(e) => setInputBranchName(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Bill ID" />
          <Input
            focusBorderColor="black"
            placeholder="Input Bill ID"
            borderRadius="16px"
            value={inputBill}
            onChange={(e) => setBill(e.target.value)}
          />
        </InputGroup>
      </SimpleGrid>
    </Flex>

  );
}
